// import { ReactComponent as ErrorIcon } from "../../../assets/error.svg";
import "./style.scss";

export default function InputError({ errorMessage, reverse = false }) {
  const inputClass = {
    base: "error-input",
    reverse: "reverse",
  };

  return (
    <div className={`${inputClass.base} ${reverse ? inputClass.reverse : ""}`}>
      {/* <span className="error-icon">
        <ErrorIcon />
      </span> */}
      <p className="error-message">{errorMessage}</p>
    </div>
  );
}
